import './style/introDialog.scss';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {BluemateDialog} from '../../controls';
import Image from '../../misc/image';

interface Props {
    onClose: VoidFunction;
    onConfirm: VoidFunction;
    active: boolean;
}

export default function IntroDialog(props: Props) {
    const {onClose, onConfirm, active} = props;
    const {t} = useTranslation();

    return (
        <BluemateDialog
            active={active}
            onClose={onClose}
            onConfirm={onConfirm}
            title={t('products.intro.title', 'Fysieke QR codes voor meer reviews')}
            confirmLabel={t('products.intro.gotIt', 'Begrepen')}
            hideCancel
            className='products-intro-dialog'
            width='34rem'
        >
            <p className='intro-paragraph'>
                {t(
                    'products.intro.body2',
                    'Gebruik fysieke QR-codes voor meer productreviews. Download en print de unieke QR-code per product en stop hem bij je verpakking. Scannen brengt klanten direct naar de reviewpagina van het product op bol, zodat een review achterlaten makkelijk is. We houden het aantal scans bij.'
                )}
            </p>
            <Image
                name='products-intro'
                fallbackExtension='jpg'
                alt={t('products.intro.imageAlt', 'QR-kaartje in een pakket')}
                className='intro-image'
                style={{width: '100%', maxWidth: '100%', height: 'auto'}}
            />
        </BluemateDialog>
    );
}
